module.exports = __webpack_public_path__ + "static/media/background.c5093c97.jpg";